import { useEffect } from "react";

type SeoProps = {
  title: string;
  description: string;
  canonical?: string;
};

const upsertMeta = (attrs: { name?: string; property?: string; content: string }) => {
  const selector = attrs.name
    ? `meta[name="${attrs.name}"]`
    : `meta[property="${attrs.property}"]`;
  let element = document.querySelector(selector) as HTMLMetaElement | null;

  if (!element) {
    element = document.createElement("meta");
    if (attrs.name) {
      element.setAttribute("name", attrs.name);
    }
    if (attrs.property) {
      element.setAttribute("property", attrs.property);
    }
    document.head.appendChild(element);
  }

  element.setAttribute("content", attrs.content);
};

const upsertCanonical = (href: string) => {
  let link = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
  if (!link) {
    link = document.createElement("link");
    link.setAttribute("rel", "canonical");
    document.head.appendChild(link);
  }
  link.setAttribute("href", href);
};

const Seo = ({ title, description, canonical }: SeoProps) => {
  useEffect(() => {
    document.title = title;
    upsertMeta({ name: "description", content: description });
    upsertMeta({ property: "og:title", content: title });
    upsertMeta({ property: "og:description", content: description });
    upsertMeta({ name: "twitter:title", content: title });
    upsertMeta({ name: "twitter:description", content: description });

    if (canonical) {
      upsertCanonical(canonical);
    }
  }, [title, description, canonical]);

  return null;
};

export default Seo;
